import React from 'react';
import { motion } from 'framer-motion';
import { MetronomeProvider } from '../contexts/MetronomeContext';
import TempoControl from './TempoControl';
import BeatDisplay from './BeatDisplay';
import VolumeControls from './VolumeControls';
import RhythmVolumeControls from './RhythmVolumeControls';

const MainPanel = () => {
  return (
    <MetronomeProvider>
      <motion.main 
        className="max-w-5xl mx-auto bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        <div className="p-3 sm:p-4 md:p-6">
          {/* Mobile-first responsive layout */}
          <div className="space-y-4 sm:space-y-6">
            {/* Mobile: Stack vertically, Desktop: Grid layout */}
            <div className="block md:hidden space-y-4">
              {/* Mobile: Tempo Control at top */}
              <div className="w-full">
                <TempoControl />
              </div>
              
              {/* Mobile: Beat Display */}
              <div className="w-full">
                <BeatDisplay />
              </div>
              
              {/* Mobile: Volume Controls in tabs/accordion */}
              <div className="w-full">
                <VolumeControls />
              </div>
              
              <div className="w-full">
                <RhythmVolumeControls />
              </div>
            </div>
            
            {/* Desktop: Original grid layout */}
            <div className="hidden md:grid md:grid-cols-12 gap-6">
              {/* Left: Tempo Control */}
              <div className="md:col-span-3">
                <TempoControl />
              </div>
              
              {/* Center: Beat Display */}
              <div className="md:col-span-5">
                <BeatDisplay />
              </div>
              
              {/* Right: Volume Controls */}
              <div className="md:col-span-4">
                <VolumeControls />
                
                {/* Add Rhythm Volume Controls */}
                <div className="mt-6">
                  <RhythmVolumeControls />
                </div>
              </div>
            </div>
          </div>
        </div>
      </motion.main>
    </MetronomeProvider>
  );
};

export default MainPanel;